import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Radio,
    RadioGroup,
    FormControlLabel,
} from "@mui/material";
import { useSelector } from "react-redux";
import { Close } from "../../../../Svg";

const DeliveryAddressPopup = ({ selectedAddress, setSelectedAddress, setOpen, open, handleSubmit }) => {

    const { customer } = useSelector((state) => state.customer)

    console.log(selectedAddress);


    return (
        <div>

            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        Select Delivery Address
                        <div onClick={() => setOpen(false)} style={{ cursor: 'pointer' }}>

                            {Close()}
                        </div>
                    </div>

                </DialogTitle>
                <DialogContent>
                    <RadioGroup
                        value={JSON.stringify(selectedAddress)}
                        onChange={(e) => setSelectedAddress(JSON.parse(e.target.value))}

                    >
                        {customer?.shippingAddress?.map((item) => (
                            <FormControlLabel
                                key={item._id}
                                value={JSON.stringify(item)}
                                control={<Radio />}
                                label={
                                    <div>

                                        <p style={{ margin: 0, fontSize: "18px", color: "#17183B", fontWeight: '400' }}>
                                            {item.factoryUnits}
                                        </p>
                                        <p style={{ margin: 0, fontSize: "12px", color: "black" }}>
                                            {item?.streetAddress},{item?.state}-{item?.zipCode} {item?.country}
                                        </p>
                                    </div>
                                }
                                style={{
                                    display: "flex",
                                    padding: "10px",
                                    border: "1px solid #ccc",
                                    borderRadius: "8px",
                                    marginBottom: "10px",
                                }}
                            />
                        ))}
                    </RadioGroup>
                </DialogContent>
                <DialogActions>

                    <Button
                        variant="contained"
                        style={{ backgroundColor: selectedAddress === null ? "#8663d6" : "#512DA8", color: "white" }}
                        onClick={handleSubmit}
                        disabled={selectedAddress === null}

                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default DeliveryAddressPopup;
